import React from 'react';

function Paragraph({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M 8.25 6, v 12" />
      <path d="M 8.25 6, h 3" />
      <path d="M 11.25 6, C 13.25 6 15.75 6.5 15.75 10, C 15.75 13.5 12.75 14 11.25 14" />
      <path d="M 8.25 14, h 3" />
    </svg>
  );
}

export default Paragraph;
